<template>
  <div class="fixed bottom-6 right-6 w-full max-w-sm bg-white rounded-xl shadow-2xl p-4 z-[1000] border-t-4 border-brand-purple">
    <div class="flex items-start">
      <div class="flex-shrink-0 pt-0.5">
        <svg class="h-8 w-8 text-brand-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>
      </div>
      <div class="ml-3 w-0 flex-1">
        <p class="text-sm font-bold text-gray-900">Recording Reminder</p>
        <p class="mt-1 text-sm text-gray-600">
          Your recording with <span class="font-semibold">{{ notification.guestName }}</span> is scheduled for {{ formattedDate }}.
        </p>
        <!-- Conditional Warning -->
        <div v-if="notification.status === 'pending_host_signature'" class="mt-2 p-2 bg-yellow-100 border-l-4 border-yellow-400">
          <p class="text-xs text-yellow-800">
            <span class="font-bold">Action Required:</span> The guest release form is still waiting for your signature.
          </p>
          <router-link :to="`/submission/${notification.id}`" class="text-xs font-semibold text-brand-purple hover:underline">
            Sign Now &rarr;
          </router-link>
        </div>
      </div>
      <div class="ml-4 flex-shrink-0 flex">
        <button @click="$emit('dismiss')" class="inline-flex text-gray-400 rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-purple">
          <span class="sr-only">Close</span>
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationPopup',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  emits: ['dismiss'],
  computed: {
    formattedDate() {
      if (!this.notification.recordingDate?.toDate) return 'an upcoming date';
      const date = this.notification.recordingDate.toDate();
      const options = { weekday: 'long', hour: '2-digit', minute: '2-digit' };
      return new Intl.DateTimeFormat('en-GB', options).format(date);
    },
  },
};
</script>